import DateTimeOperations from '@modules/husleie-framework/src/static-classes/DateTimeOperations.class';
import { Session, SessionType } from '@modules/husleie-framework/src/types/Session.entity';
import { Tenant } from '@modules/husleie-framework/src/types/Tenant.entity';
import CommonConversionOperations from '@modules/store/common/static-classes/CommonConversionOperations.class';
import LandlordConversionOperations from '@modules/store/landlord/static-classes/LandlordConversionOperations';
import RentalObjectConversionOperations from '@modules/store/rentalObject/static-classes/RentalObjectConversionOperations';
import TenantConversionOperations from '@modules/store/tenant/static-classes/TenantConversionOperations';
import { UserTranslationOptions } from '@modules/store/user/types/UserTranslationOptions.entity';

export default class SessionConversionOperations extends CommonConversionOperations {
  static apiToInternal(type: SessionType, apiInspectionReport: any, options: UserTranslationOptions): Session {
    return this.convertAPIBodyToSession(type, apiInspectionReport, options);
  }

  static internalToApi(session: Session): any {
    return this.convertSessionToAPI(session);
  }

  private static convertSessionToAPI(session: Session): any {
    const sessionAPI: any = {
      type: session.type,

      landlord: LandlordConversionOperations.internalToApi(session.landlord),
      tenant: TenantConversionOperations.internalToApi(session.tenant),
      coTenants: this.convertCoTenantsToAPI(session.coTenants),
      rentalObject: RentalObjectConversionOperations.internalToApi(session.rentalObject),

      inspectionReport: {
        comment: session.comment,
        images: this.internalImagesToApi(session.images),
      },
    };

    return sessionAPI;
  }

  private static convertAPIBodyToSession(
    type: SessionType,
    apiInspectionReport: any,
    options: UserTranslationOptions
  ): Session {
    const session: Session = {
      uuid: apiInspectionReport.uuid,
      signingUuid: apiInspectionReport.signingUuid,
      signerUuid: apiInspectionReport.signerUuid,
      signerRole: apiInspectionReport.signerRole,
      type,
      status: apiInspectionReport.status,

      landlord: LandlordConversionOperations.apiToInternal(apiInspectionReport.landlord, options),
      tenant: TenantConversionOperations.apiToInternal(apiInspectionReport.tenant, options),
      coTenants: this.convertAPICoTenantsToInternal(apiInspectionReport.coTenants, options),
      rentalObject: RentalObjectConversionOperations.apiToInternal(apiInspectionReport.rentalObject),
      tenancyId: apiInspectionReport.tenancyId,

      comment: apiInspectionReport.inspectionReport?.comment,
      images: this.apiImagesToInternal(apiInspectionReport.inspectionReport?.images),
      created: DateTimeOperations.apiDateToInternalDate(apiInspectionReport.created),
      modified: DateTimeOperations.apiDateToInternalDate(apiInspectionReport.modified),
    };

    return session;
  }

  private static convertCoTenantsToAPI(coTenants: Tenant[]): any[] {
    const apiCoTenants: any[] = [];
    coTenants.map((cot: Tenant) => {
      apiCoTenants.push(TenantConversionOperations.internalToApi(cot));
    });
    return apiCoTenants;
  }

  private static convertAPICoTenantsToInternal(apiCoTenants: any[], options: UserTranslationOptions): Tenant[] {
    const coTenants: Tenant[] = [];
    if (apiCoTenants && apiCoTenants.length) {
      apiCoTenants.map((cot: any) => {
        coTenants.push(TenantConversionOperations.apiToInternal(cot, options));
      });
    }
    return coTenants;
  }
}
